import { useEffect, useState } from "react";

let deferredPrompt = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  notify();
});

window.addEventListener("appinstalled", () => {
  deferredPrompt = null;
  localStorage.setItem("matiq_installed", "1");
  notify();
});

if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true) localStorage.setItem("matiq_installed", "1");

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isAndroid = () => /android/i.test(navigator.userAgent);

export function useInstall() {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((n) => n + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);

  const promptInstall = async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    deferredPrompt = null;
    if (outcome === "accepted") localStorage.setItem("matiq_installed", "1");
    notify();
    return outcome === "accepted";
  };

  return {
    installed: isStandalone() || localStorage.getItem("matiq_installed") === "1",
    canPrompt: !!deferredPrompt,
    ios: isIOS(),
    android: isAndroid(),
    promptInstall,
  };
}
